export enum ApplicationStepperLabels {
  SUMMARY = 'Summary',
  FINAL = 'Final',
  PRODUCT_INFO = 'Product info',
  KNOWLEDGE_TEST_1 = 'Knowledge test 1',
  KNOWLEDGE_TEST_2 = 'Knowledge test 2',
  KNOWLEDGE_TEST_3 = 'Knowledge test 3',
  PERSONAL_DATA = 'Personal data',
  IDENTITY_VERIFICATION = 'IDENTITY_VERIFICATION',
  THANK_YOU_PAGE = 'Thank you'
}
